// 大町の気温を取得
let url_amedasu = "https://jjwd.info/api/v2/stations/search?pref_ja=%E9%95%B7%E9%87%8E&address=%E5%A4%A7%E7%94%BA";
// let url_amedasu = "https://jjwd.info/api/v2/station/48191";
let request = new XMLHttpRequest();
request.open('GET', url_amedasu);
request.responseType = 'json';
request.send();
request.onload = function() {
  const maxtemp = request.response;
 var temp = maxtemp.stations[0].max_temp.temp_daily_max;
//    $("#temp").text(Math.floor(temp) + "℃");

var temp2 = "'"+ Math.floor(temp) + "'";
var ary = temp2.split('');
 ary.shift();   
 ary.pop();

    
    $('#temp').prepend('<img class="num" src="https://cdn.shopify.com/s/files/1/0551/6446/9406/files/c_ico.svg">');
    
    if(typeof ary[3] != 'undefined'){
        $('#temp').prepend('<img class="num" src="https://cdn.shopify.com/s/files/1/0551/6446/9406/files/t'+ ary[3] +'.svg">');
    }     
    if(typeof ary[2] != 'undefined'){
        $('#temp').prepend('<img class="num" src="https://cdn.shopify.com/s/files/1/0551/6446/9406/files/t'+ ary[2] +'.svg">');
    }
    if(typeof ary[1] != 'undefined'){
        $('#temp').prepend('<img class="num" src="https://cdn.shopify.com/s/files/1/0551/6446/9406/files/t'+ ary[1] +'.svg">');
    }
    if(ary[0] == "-"){
        $('#temp').prepend('<img class="num" src="https://cdn.shopify.com/s/files/1/0551/6446/9406/files/t.svg">');
    }else{
        $('#temp').prepend('<img class="num" src="https://cdn.shopify.com/s/files/1/0551/6446/9406/files/t'+ ary[0] +'.svg">');
    }
    
    
}
    

    
// 長野の予報を取得
let url = "https://www.jma.go.jp/bosai/forecast/data/forecast/200000.json";
    
fetch(url)
    .then(function(response) {
        return response.json();
    })
    .then(function(weatherCodes) {
        let area = weatherCodes[0].timeSeries[0].areas[0];
        var icono = area.weatherCodes[0];
    
    
        
        //weatherCodesをベースに天気アイコンを選択
        if (icono == 100){var svgno = "100.svg"}
        else if (icono == 101){var svgno = "101.svg"}
        else if (icono == 102){var svgno = "102.svg"}
        else if (icono == 103){var svgno = "102.svg"}
        else if (icono == 104){var svgno = "104.svg"}
        else if (icono == 105){var svgno = "104.svg"}
        else if (icono == 106){var svgno = "102.svg"}
        else if (icono == 107){var svgno = "102.svg"}
        else if (icono == 108){var svgno = "102.svg"}
        else if (icono == 110){var svgno = "110.svg"}
        else if (icono == 111){var svgno = "110.svg"}
        else if (icono == 112){var svgno = "112.svg"}
        else if (icono == 113){var svgno = "112.svg"}
        else if (icono == 114){var svgno = "112.svg"}
        else if (icono == 115){var svgno = "115.svg"}
        else if (icono == 116){var svgno = "115.svg"}
        else if (icono == 117){var svgno = "115.svg"}
        else if (icono == 118){var svgno = "112.svg"}
        else if (icono == 119){var svgno = "112.svg"}
        else if (icono == 120){var svgno = "102.svg"}
        else if (icono == 121){var svgno = "102.svg"}
        else if (icono == 122){var svgno = "112.svg"}
        else if (icono == 123){var svgno = "100.svg"}
        else if (icono == 124){var svgno = "100.svg"}
        else if (icono == 125){var svgno = "112.svg"}
        else if (icono == 126){var svgno = "112.svg"}
        else if (icono == 127){var svgno = "112.svg"}
        else if (icono == 128){var svgno = "112.svg"}
        else if (icono == 130){var svgno = "100.svg"}
        else if (icono == 131){var svgno = "100.svg"}
        else if (icono == 132){var svgno = "101.svg"}
        else if (icono == 140){var svgno = "102.svg"}
        else if (icono == 160){var svgno = "104.svg"}
        else if (icono == 170){var svgno = "104.svg"}
        else if (icono == 181){var svgno = "115.svg"}
        else if (icono == 200){var svgno = "200.svg"}
        else if (icono == 201){var svgno = "201.svg"}
        else if (icono == 202){var svgno = "202.svg"}
        else if (icono == 203){var svgno = "202.svg"}
        else if (icono == 204){var svgno = "204.svg"}
        else if (icono == 205){var svgno = "204.svg"}
        else if (icono == 206){var svgno = "202.svg"}
        else if (icono == 207){var svgno = "202.svg"}
        else if (icono == 208){var svgno = "202.svg"}
        else if (icono == 209){var svgno = "200.svg"}
        else if (icono == 210){var svgno = "210.svg"}
        else if (icono == 211){var svgno = "210.svg"}
        else if (icono == 212){var svgno = "212.svg"}
        else if (icono == 213){var svgno = "212.svg"}
        else if (icono == 214){var svgno = "212.svg"}
        else if (icono == 215){var svgno = "215.svg"}
        else if (icono == 216){var svgno = "215.svg"}
        else if (icono == 217){var svgno = "215.svg"}
        else if (icono == 218){var svgno = "212.svg"}
        else if (icono == 219){var svgno = "212.svg"}
        else if (icono == 220){var svgno = "202.svg"}
        else if (icono == 221){var svgno = "202.svg"}
        else if (icono == 222){var svgno = "212.svg"}
        else if (icono == 223){var svgno = "201.svg"}
        else if (icono == 224){var svgno = "212.svg"}
        else if (icono == 225){var svgno = "212.svg"}
        else if (icono == 226){var svgno = "212.svg"}
        else if (icono == 228){var svgno = "215.svg"}
        else if (icono == 229){var svgno = "215.svg"}
        else if (icono == 230){var svgno = "215.svg"}
        else if (icono == 231){var svgno = "200.svg"}
        else if (icono == 240){var svgno = "202.svg"}
        else if (icono == 250){var svgno = "204.svg"}
        else if (icono == 260){var svgno = "204.svg"}
        else if (icono == 270){var svgno = "204.svg"}
        else if (icono == 281){var svgno = "215.svg"}
        else if (icono == 300){var svgno = "300.svg"}
        else if (icono == 301){var svgno = "301.svg"}
        else if (icono == 302){var svgno = "302.svg"}
        else if (icono == 303){var svgno = "303.svg"}
        else if (icono == 304){var svgno = "300.svg"}
        else if (icono == 306){var svgno = "300.svg"}
        else if (icono == 308){var svgno = "308.svg"}
        else if (icono == 309){var svgno = "303.svg"}
        else if (icono == 311){var svgno = "311.svg"}
        else if (icono == 313){var svgno = "313.svg"}
        else if (icono == 314){var svgno = "314.svg"}
        else if (icono == 315){var svgno = "314.svg"}
        else if (icono == 316){var svgno = "311.svg"}
        else if (icono == 317){var svgno = "313.svg"}
        else if (icono == 320){var svgno = "311.svg"}
        else if (icono == 321){var svgno = "313.svg"}
        else if (icono == 322){var svgno = "303.svg"}
        else if (icono == 323){var svgno = "311.svg"}
        else if (icono == 324){var svgno = "311.svg"}
        else if (icono == 325){var svgno = "311.svg"}
        else if (icono == 326){var svgno = "314.svg"}
        else if (icono == 327){var svgno = "314.svg"}
        else if (icono == 328){var svgno = "300.svg"}
        else if (icono == 329){var svgno = "300.svg"}
        else if (icono == 340){var svgno = "400.svg"}
        else if (icono == 350){var svgno = "300.svg"}
        else if (icono == 361){var svgno = "411.svg"}
        else if (icono == 371){var svgno = "413.svg"}
        else if (icono == 400){var svgno = "400.svg"}
        else if (icono == 401){var svgno = "401.svg"}
        else if (icono == 402){var svgno = "402.svg"}
        else if (icono == 403){var svgno = "403.svg"}
        else if (icono == 405){var svgno = "400.svg"}
        else if (icono == 406){var svgno = "406.svg"}
        else if (icono == 407){var svgno = "406.svg"}
        else if (icono == 409){var svgno = "403.svg"}
        else if (icono == 411){var svgno = "411.svg"}
        else if (icono == 413){var svgno = "413.svg"}
        else if (icono == 414){var svgno = "414.svg"}
        else if (icono == 420){var svgno = "411.svg"}
        else if (icono == 421){var svgno = "413.svg"}
        else if (icono == 422){var svgno = "414.svg"}
        else if (icono == 423){var svgno = "414.svg"}
        else if (icono == 425){var svgno = "400.svg"}
        else if (icono == 426){var svgno = "400.svg"}
        else if (icono == 427){var svgno = "400.svg"}
        else if (icono == 450){var svgno = "400.svg"}
    
         document.getElementById('wico').src="https://cdn.shopify.com/s/files/1/0551/6446/9406/files/"+svgno;
    });